"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reducers = require("../reducers");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var createWaiterMiddleWare = function createWaiterMiddleWare(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (_typeof(action) === 'object' && typeof action.callback === 'function') {
          dispatch((0, _reducers.startWaitAction)(action.type.toString()));

          if (action.callback.prototype && action.callback.prototype.toString() === '[object Generator]') {
            return dispatch(_objectSpread(_objectSpread({}, action.action), {}, {
              continue: true,
              extraArgument: extraArgument
            }));
          }

          return action.callback(dispatch, getState, extraArgument);
        }

        if (typeof action.type === 'string' && (action.type.endsWith('success/@@end') || action.type.endsWith('error/@@end'))) {
          dispatch((0, _reducers.endWaitAction)(action.type.replace(/(?:[^\]].*?\]\s+?)(.*)/, '$1').replace(/\/success\/@@end|\/error\/@@end/, '')));
        }

        return next(action);
      };
    };
  };
};

var waiter = createWaiterMiddleWare();
waiter.withExtraArgument = createWaiterMiddleWare;
var _default = waiter;
exports.default = _default;